import { render, staticRenderFns } from "./learning-effect.vue?vue&type=template&id=fe9947f2&scoped=true"
import script from "./learning-effect.vue?vue&type=script&lang=js"
export * from "./learning-effect.vue?vue&type=script&lang=js"
import style0 from "./learning-effect.vue?vue&type=style&index=0&id=fe9947f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9947f2",
  null
  
)

export default component.exports